<script setup lang="ts">
</script>

<template>
  <span
    :style="{
      'margin': 'calc(0px - var(--inline-gap) / 2) calc(0px - var(--block-gap) / 2)',
      'flex-grow': 1
    }"
  />
</template>
